import { StrictMode } from 'react'
import { RouterProvider } from '@tanstack/react-router'
import { WebUpdateNotice } from '@/components/web-update-notice.tsx'
import { getRouter } from '@/router.tsx'
import { createAppRouterContext } from '@/trpc/context.ts'
import { ThemeProvider } from './theme-provider.tsx'
import { TrpcProvider } from './trpc-provider.tsx'

const appRouterContext = createAppRouterContext()
const router = getRouter(appRouterContext)

export function AppProviders() {
  return (
    <StrictMode>
      <ThemeProvider>
        <WebUpdateNotice />
        <TrpcProvider context={appRouterContext}>
          <RouterProvider router={router} />
        </TrpcProvider>
      </ThemeProvider>
    </StrictMode>
  )
}
